export class MultiSelect {
  id?: number;
  displayText?: string;
  Code?: string;
  Name?: string;
}

export class AutoComplete {
  Id?: number;
  SuggestionText: string;
  DisplayTextForSelectedValue: string;
  SelectedValue: string;
}

export enum EllipsisDirection {
  Front = 'front',
  Back = 'back',
  None = 'none'
}

export enum ColumnType {
  General = 'general',
  DateType = 'datetype',
  NullHeader = 'nullheader',
  CheckBox = 'checkbox'
}

export interface ColumnConfig {
  columnName: string;
  isClickable: boolean;
  ellipsisDirection: EllipsisDirection;
  columnType: ColumnType;
  isSortable: boolean;
  isPuid?: boolean;
  width?: number;
  minWidth?: number;
}

export interface NodeStructure {
  Id?: string | number;
  Name: string;
  Children?: NodeStructure[];
}